angular
    .module('MW.CustomValidation.ContactManagerUsernameService', [])
    .service('ContactManagerUsernameService', [
        function() {
            'use strict';

            /**
             * This regular expression will validate any URL matching ://(or www.)facebook.com/(username)
             * The output array should have at least 4 results, if it's less than that it is invalid.
             */
            var FACEBOOK_URL_REGEX = /(:\/\/facebook\.com\/|www\.facebook\.com\/|facebook\.com\/)(profile\.php\?id\=([0-9]*)|[A-Za-z0-9\.]*)/,
                FACEBOOK_USER_NAME_REGEX = /([A-Za-z0-9\.]{5,})/,
                FACEBOOK_PROFILE_ID_REGEX = /[0-9]*/,
                TWITTER_URL_REGEX = /(:\/\/twitter\.com\/|www\.twitter\.com\/|twitter\.com\/)([A-Za-z0-9_]*)/,
                TWITTER_USER_NAME_REGEX = /@?[a-zA-Z0-9_]{1,15}/;

            this.isValidUrl = function isValidUrl(url) {
                var regExMatches,
                    URL_REGEX = /((https?):\/\/|(mailto:)[A-Za-z0-9._%+-]+@|www\.([^\s.;,(){}<>"]+\.)+|([^\s.;,(){}<>"]+\.)+[^\s.;,(){}<>"0-9]+\/)[A-Za-z-._~:\/?#\[\]@!$&'()*+,;=<>]*[^\s.;,(){}<>"]*/i,
                    filteredRegExList;

                regExMatches = url.match(URL_REGEX);

                filteredRegExList = this.searchRegExResults(url , regExMatches);
                return filteredRegExList.length > 0;
            };

            this.searchRegExResults = function searchRegExResults(needle, haystack) {
                var resultList;
                if (haystack === null) {
                    return false;
                } else if (haystack.length > 0 ) {
                    resultList = haystack.filter(function (value) {
                        return value === needle;
                    });
                }
                return resultList;
            };
            this.twitterValidation = function twitterValidation(input){
                 if(this.isValidUrl(input)){
                    return matchTwitterUrl(input);
                }else{
                    return validateTwitterUsername(input);
                }
            };

            function matchTwitterUrl(input){
                try{
                    var matches = input.match(TWITTER_URL_REGEX);

                    return validateTwitterUsername(matches[2]);
                } catch(e){
                    return false;
                }
            }

            function validateTwitterUsername(input){
                var regExResult = input.match(TWITTER_USER_NAME_REGEX);
                return ( !!regExResult && regExResult[0].length === input.length);
            }

            this.facebookValidation = function facebookValidation(input){
                if(this.isValidUrl(input)){
                    return matchFacebookUrl(input);
                }else{
                    return validateFacebookUsername(input) || validateFacebookProfileID(input);
                }
            };

            function matchFacebookUrl(input){
                try{
                    var matches = input.match(FACEBOOK_URL_REGEX);
                    if(matches[3]){
                        return validateFacebookProfileID(matches[3]);
                    }else if(matches[2]){
                        return validateFacebookUsername(matches[2]);
                    }else{
                        throw 'Invalid input';
                    }

                } catch(e){
                    //default to false
                    return false;

                }
            }

            function validateFacebookProfileID(input){
                var m = input.match(FACEBOOK_PROFILE_ID_REGEX);
                return (!!m && m[0].length === input.length);
            }

            function validateFacebookUsername(input){
                var m = input.match(FACEBOOK_USER_NAME_REGEX);
                return (!!m && m[1].length === input.length);
            }

            this.getTwitterUsername = function getTwitterUsername(input){
                var valid = this.twitterValidation(input),
                    m;

                if(!valid){return null;}

                if(this.isValidUrl(input)){
                    m = input.match(TWITTER_URL_REGEX);
                    return m[2];
                }else{
                    return input.match(TWITTER_USER_NAME_REGEX)[0];
                }
            };

            this.getFacebookUsername = function getFacebookUsername(input){
                var valid = this.facebookValidation(input),
                    m;

                if(!valid){return null;}

                if(this.isValidUrl(input)){
                    m = input.match(FACEBOOK_URL_REGEX);
                    return m[3] || m[2];
                }else{
                    return input.match(FACEBOOK_USER_NAME_REGEX) ? input.match(FACEBOOK_USER_NAME_REGEX)[1] : input.match(FACEBOOK_PROFILE_ID_REGEX)[0];
                }
            };
        }
    ]);
